var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sair",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.714,
    height: 40,
    viewBox: "0 0 45.714 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1030",
    "data-name": "Caminho 1030",
    d: "M14.286,37.714a2.857,2.857,0,1,0,0-5.714H8.571A8.574,8.574,0,0,0,0,40.571V63.429A8.574,8.574,0,0,0,8.571,72h5.714a2.857,2.857,0,1,0,0-5.714H8.571a2.854,2.854,0,0,1-2.857-2.857V40.571a2.854,2.854,0,0,1,2.857-2.857ZM45.045,53.554a2.137,2.137,0,0,0,0-3.107L32.188,38.3a2.143,2.143,0,0,0-3.616,1.554v6.429H17.143a2.854,2.854,0,0,0-2.857,2.857v5.714a2.854,2.854,0,0,0,2.857,2.857H28.571v6.429A2.143,2.143,0,0,0,32.188,65.7Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.bf302c6b89e1ef0055dcdf46da8741db.svg";
export { ForwardRef as ReactComponent };